type Direction = "up" | "down";

export const ChevronIcon = ({ direction }: { direction: Direction }) => {
  const transform = direction === "up" ? "rotate-180" : "";
  return (
    <div className={`${transform} transition-transform duration-300`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24"
        viewBox="0 -960 960 960"
        width="24"
      >
        <path d="m296-345-56-56 240-240 240 240-56 56-184-184-184 184Z" />
      </svg>
    </div>
  );
};
